import { Component, Vue, Prop } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import TaskApi from '@/api/task'
let id: any = 0
import BillApi from '@/api/bill2'
import VisitorApi from '@/api/visitor'
import { idCard } from '@/utils/validator'
import Moment from 'moment'
import { nameLength } from '@/config/global'
import { caseNoReg } from '@/utils/regExp'
import { debounce } from '@/utils/util'
const debounceSearch = debounce(300)
const PIAO_JU_CHA_XUN = '6'
const JIU_ZHEN_JI_LU = '14'

@Component({})
export default class AddTaskMixin extends Vue {
	public addForm: any = {}
	public addLoading: boolean = false
	public phoneId: number = 0
	public hasNoCarNo: boolean = false
	public isInjured: boolean = false
	public searchArea: any = []
	public noData: boolean = false
	public searchHospital: any = []
	public localSearch: any = ''
	public fetching: boolean = false
	public sameWithPublisher: boolean = false
	public areaName: string = ''
	public resurvey: boolean = false
	public endOpen: boolean = false
	public isPatient: any = true
	public submitting: boolean = false
	public taskType: any = ''
	public fileId: any = ''
	public picName: any = ''
	public orderId: any = ''
	public fileList: any = []
	public nameLength: any = nameLength
	public provList: any[] = []
	public medicalOrgList: any[] = []
	public relateRecordId = ''
	public parentOrderId = ''
	public caseNoReg: any = caseNoReg

	public handleRemove() {
		this.fileList = []
	}

	public beforeUpload(e: any, fileList: any, limit: number = 2) {
		if (e.size > limit * 1024 * 1024) {
			this.$message.error(`文件大小不能超过${limit}M`)
			return false
		}
		const formData = new FormData()
		formData.append('filecontent', e)
		VisitorApi.uploadFile({
			formData,
		}).then((res: any) => {
			this.fileList = [e]
			this.fileId = res.data.fileId
			this.picName = e.name
			this.$message.success('上传成功')
		})
		return false
	}

	public handleEndOpenChange(open: boolean) {
		this.endOpen = open
	}

	public disabledEndDate(endValue: any) {
		const startValue: any = this.addForm.getFieldValue('startIssueDate')
		const laterThanToday = endValue.valueOf() > Moment().endOf('day')
		if (!endValue || !startValue) {
			return laterThanToday
		}
		return startValue.valueOf() >= endValue.valueOf() || laterThanToday
	}

	public disabledStartDate(startValue: any) {
		const endValue: any = this.addForm.getFieldValue('endIssueDate')
		const laterThanToday = startValue.valueOf() > Moment().endOf('day')
		if (!startValue || !endValue) {
			return laterThanToday
		}
		return startValue.valueOf() > endValue.valueOf() || laterThanToday
	}

	public handleStartOpenChange(open: boolean) {
		if (!open) {
			this.endOpen = true
		}
	}

	public onPatientInput() {
		if (this.isPatient) {
			this.addForm.setFieldsValue({
				certigier: this.addForm.getFieldValue('injuredName'),
				certigierPhone: this.addForm.getFieldValue('injuredPhone'),
			})
		}
	}

	public onIsPatient() {
		this.isPatient = !this.isPatient
		if (this.isPatient) {
			this.addForm.setFieldsValue({
				certigier: this.addForm.getFieldValue('injuredName'),
				certigierPhone: this.addForm.getFieldValue('injuredPhone'),
			})
		}
	}

	public checkIdNo(rule: string, value: string, cb: any) {
		const idNo = value

		if (!idNo) {
			cb(new Error('请输入就诊人身份证号码'))
		} else if (!idCard(idNo)) {
			cb(new Error('请输入正确的身份证号码'))
		} else {
			cb()
		}
	}

	public onOrgNameFocus() {
		if (!this.addForm.getFieldValue('provinceCode')) {
			this.$message.error('请先选择就诊机构所在省份')
		}
	}

	public onSearchOrgName(value: string) {
		let provCode = this.addForm.getFieldValue('provinceCode')
		if (!provCode) {
			return
		}
		if (!value) {
			return
		}
		debounceSearch(() => {
			BillApi.medicalOrg({ keyword: value, provinceCode: provCode }).then(
				(res: any) => {
					let data = res && res.data
					if (!(data && data.length > 0)) {
						// 允许手动输入
						this.addForm.setFieldsValue({
							medicalOrgName: { key: '', label: value },
						})
					} else {
						// 必须选择
						this.medicalOrgList = data
					}
				}
			)
		})
	}

	public onSearchProv(value: string) {
		debounceSearch(() => {
			this.getProvList(value)
		})
	}

	public getProvList(keyword: string = '') {
		BillApi.invoiceProvince(keyword).then((res: any) => {
			this.provList = (res && res.data) || []
		})
	}

	public created() {
		this.addForm = this.$form.createForm(this)
	}

	public bill2Research(row: any, failCb: any = null, successCb: any = null) {
		this.submitting = true
		BillApi.researchInvoice(row.orderId)
			.then(() => {
				this.pollingAdd(row, failCb, successCb)
			})
			.catch((err: any) => {
				this.submitting = false
				console.error('invoice research failed: ', err)
			})
	}

	public pollingAdd(row: any, failCb: any = null, successCb: any = null) {
		this.submitting = true
		const orderId = row.orderId || this.orderId
		const timer = setInterval(async () => {
			const res = await BillApi.invoiceSearchResult(orderId)
			const data = res.data
			if (!data.result || data.result !== 'searching') {
				clearInterval(timer)
				this.submitting = false
			}
			if (['exception', 'none'].includes(data.result)) {
				// 就诊记录无需重新查询
				if (data.taskType === JIU_ZHEN_JI_LU) {
					this.$info({
						title: '提示',
						content: (h: any) => {
							return h('div', {}, [
								h('span', '系统查询就诊人'),
								h(
									'span',
									{ style: { color: '#2467d5' } },
									`${row.patientName}`
								),
								h('span', '，身份证'),
								h('span', { style: { color: '#2467d5' } }, `${row.idCard}`),
								h('span', '无医院就诊记录。'),
							])
						},
						onOk: () => {
							if (failCb) {
								failCb()
							}
						},
					})
				} else {
					this.$confirm({
						title: '提示',
						content: (h: any) => {
							if (data.taskType === PIAO_JU_CHA_XUN) {
								if (data.departmentName && data.departmentName.length > 0) {
									let text = ''
									data.departmentName.forEach((item: any, index: number) => {
										text += (index === 0 ? '' : '、') + item.deptName
									})
									return h('div', {}, [
										h('span', '您所查询的医院已开通'),
										h('span', { style: { color: '#ff0000' } }, text),
										h(
											'span',
											'，但是查询的发票信息，系统无返回，请联系中保管理员进行确认！'
										),
									])
								} else {
									return h('div', {}, [
										h('span', '您所查询的医院'),
										h('span', { style: { color: '#ff0000' } }, '暂未开通'),
										h('span', '，请和中保管理员确认医院开通进度！'),
									])
								}
							} else {
								return h('div', {}, [
									h('span', '您所查询的发票信息，'),
									h('span', { style: { color: '#ff0000' } }, '系统无法返回！'),
								])
							}
						},
						cancelText: '重新查询',
						onOk: () => {
							if (failCb) {
								failCb()
							}
						},
						onCancel: () => {
							clearInterval(timer)
							this.bill2Research(row, failCb, successCb)
						},
					})
				}
			} else if (data.result === 'hadResult') {
				if (successCb) {
					successCb()
				}

				this.$multiTab.open(`/bill2/taskDetail/${orderId}/${data.taskType}`)
			}
		}, 1500)
	}

	public onFailOk() {
		this.addForm.resetFields()
		this.fileList = []
	}

	public onOk() {
		this.isPatient = false
		this.fileList = []
		this.addForm.resetFields()
		this.$multiTab.closeCurrentPage()
	}

	public onTaskAdd(e: any) {
		e.preventDefault()
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				if (!this.fileList.length) {
					return this.$message.error('请上传授权文件')
				}
				if (
					values.medicalOrgName.label &&
					values.medicalOrgName.label.length > 50
				) {
					return this.$message.error('就诊机构名称限制50个字符')
				}

				values = cloneDeep(values)
				if (values.range) {
					values.startIssueDate =
						values.range[0] && values.range[0].format('YYYY-MM-DD')
					values.endIssueDate =
						values.range[1] && values.range[1].format('YYYY-MM-DD')
					delete values.range
				}
				values.taskType = this.taskType
				values.authorizeInfoId = this.fileId
				values.authorizeInfoName = this.picName
				let { label, key } = values.medicalOrgName
				values.medicalOrgName = label
				values.medicalOrgId = key
				if (this.relateRecordId) {
					values.relateRecordId = this.relateRecordId
				}
				if (this.parentOrderId) {
					values.parentOrderId = this.parentOrderId
				}

				// values = {
				// 	"patientName": "陈红",
				// 	"telPhone": "13684251301",
				// 	"idCard": "510122198507308769",
				// 	"medicalOrgName": "医疗测试0221",
				// 	//"startIssueDate": "13566666666",
				// 	//"endIssueDate": "f68c92f6990844fb886659a8b372f11b",
				// 	"authorizeInfoId": "0add8e5f25624c79a9e11c416a7129ad",
				// 	"authorizeInfoName":"aa.pdf"
				// }
				this.addLoading = true
				BillApi.addBill(values)
					.then((res: any) => {
						this.orderId = res.data
						this.pollingAdd(
							{ orderId: this.orderId },
							() => {
								this.onFailOk()
							},
							() => {
								this.onOk()
							}
						)
						// this.$message.success(data.message || '发布成功')
						// this.onOk(res.data.id)
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}

	public onBosssoftOk() {
		this.isPatient = false
		this.fileList = []
		this.addForm.resetFields()
		this.$multiTab.closeCurrentPage()
		this.$multiTab.open('/bill2/taskList')
	}

	public onBosssoftTaskAdd(e: any) {
		e.preventDefault()
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				if (!this.fileList.length) {
					return this.$message.error('请上传授权文件')
				}
				values = cloneDeep(values)

				values.taskType = this.taskType
				values.authorizeInfoId = this.fileId
				values.authorizeInfoName = this.picName
				values.insDate = values.insDate.format('YYYY-MM-DD')

				this.addLoading = true
				BillApi.addBosssoftBill(values)
					.then((res: any) => {
						this.orderId = res.data
						this.$message.success(res.message || '发布成功')
						this.onBosssoftOk()
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}
}
